export default "__VITE_ASSET__Cth7$iTA__"